"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TooltipVisibilityProvider: function() {
        return _TooltipContext.TooltipVisibilityProvider;
    },
    useTooltipVisibility: function() {
        return _TooltipContext.useTooltipVisibility;
    }
});
const _TooltipContext = require("./TooltipContext");
